export const createPacketsNodes = [
  {
    id: "195.113.76.22",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 700, y: 450 },
    className: "server-plain non-draggable",
    data: { label: "195.113.76.22" },
  },
  {
    id: "214.17.55.99",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 100, y: 500 },
    className: "mobil non-draggable",
    data: { label: "214.17.55.99" },
  },
  {
    id: "15.103.46.12",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 700, y: 550 },
    className: "notebook non-draggable",
    data: { label: "15.103.46.12" },
  },
  {
    id: "192.168.0.1",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 300, y: 500 },
    className: "gateway non-draggable",
    data: { label: "192.168.0.1" },
  },
  {
    id: "10.0.0.1",
    type: "custom",
    dragHandle: "noDrag",
    position: { x: 500, y: 500 },
    className: "gateway non-draggable",
    data: { label: "10.0.0.1" },
  },
];
